import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { IoCloseSharp } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "../../AddVehicle.scss";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa";
import CreateModal from "../../../component/Model/CreateModel";
import FeeSelector from "../../../component/selectbox/FeeSelector";
import {
  useCreateRecordMutation,
  useGetRecordDetailsQuery,
  useUpdateRecordMutation,
} from "../../../store/api/school/PraentSlice";
import { useParentPaymentMutation } from "../../../store/api/parent/registrationSlice";
import { AddressAutocomplete } from "../../auth/parent-registration/SignUp";
import "./parent.scss";
import { useSelector } from "react-redux";
import { handleApiError } from "../../../utils/dateAndTimeConversion";

const initialStudent = {
  full_name: "",
  street: "",
  city: "",
  state: "",
  country: "",
  zip_code: "",
  latitude: "",
  longitude: "",
  is_disabled: false,
  disability_notes: "",
  dr_phone_no: "",
  bus_fee_id: "",
};

const initialState = {
  students: [initialStudent],
};

const AddKids = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [studentChildTypes, setStudentChildTypes] = useState({});
  const [feeErrors, setFeeErrors] = useState({});
  const { user } = useSelector((state) => state.UserReducer);

  // Payment modal state
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentSummary, setPaymentSummary] = useState(null);
  const [feeBreakdown, setFeeBreakdown] = useState([]);
  const [newStudentsFee, setNewStudentsFee] = useState(0);
  const [paymentFormData, setPaymentFormData] = useState({
    currency: "USD",
    paymentType: "full_payment",
  });

  // Create New Parent query
  const [createRecord, { isLoading }] = useCreateRecordMutation();
  // Update Parent
  const [updateRecord, { isLoading: isUpdateLoading }] =
    useUpdateRecordMutation();
  // Payment mutation
  const [parentPayment, { isLoading: isPaymentLoading }] =
    useParentPaymentMutation();
  // Get parent kids details query (edit mode)
  const {
    data,
    isSuccess,
    isLoading: isGetLoading,
  } = useGetRecordDetailsQuery(`students/${id}`, { skip: !id });

  // Fetch existing students — if parent has ANY registered kids, first child is already taken
  const { data: existingStudentsData } = useGetRecordDetailsQuery(
    `${user?.id}/students`,
    { skip: !user?.id || !!id },
  );
  const existingStudents = existingStudentsData?.data || [];
  const existingFirstChild = existingStudents.length > 0;

  // Student field update
  const handleChangeStudent = (index, field, value) => {
    setFormData((prev) => {
      const arr = [...prev.students];

      // 🔥 If user checked "sameAsParent"
      if (field === "sameAsParent" && value === true) {
        const address = {
          street: user.street || "",
          city: user.city || "",
          state: user.state || "",
          country: user.country || "",
          zip_code: user.zip_code || "",
          latitude: user.latitude || "",
          longitude: user.longitude || "",
        };

        arr[index] = {
          ...arr[index],
          sameAsParent: true,
          ...address,
        };
      } else {
        // normal update
        arr[index] = { ...arr[index], [field]: value };
      }

      return { ...prev, students: arr };
    });
  };

  const handleAddStudent = () => {
    setFormData((prev) => ({
      ...prev,
      students: [...prev.students, initialStudent],
    }));
  };

  // Remove a student
  const removeStudent = (idx) => {
    setFormData((prev) => ({
      ...prev,
      students: prev.students.filter((_, i) => i !== idx),
    }));
  };

  // Student autocomplete select
  const handleStudentAddressSelect = (index, address) => {
    setFormData((prev) => {
      const arr = [...prev.students];
      arr[index] = { ...arr[index], ...address };
      return { ...prev, students: arr };
    });
  };

  const validateForm = () => {
    const newErrors = {};
    // Validate students
    formData.students.forEach((student, index) => {
      if (!student.full_name || student.full_name.trim() === "") {
        newErrors[`student_${index}_name`] =
          `${t("student")} ${index + 1} ${t("name")} ${t("is")} ${t("required")}`;
      }

      if (!student.bus_fee_id && !id) {
        newErrors[`student_${index}_fee`] =
          `${t("student")} ${index + 1} ${t("fee")} ${t("is")} ${t("required")}`;
      }

      if (!student.street || student.street.trim() === "") {
        newErrors[`student_${index}_street`] =
          `${t("student")} ${index + 1} ${t("address")} ${t("is")} ${t("required")}`;
      }

      // If student has special needs, validate required fields
      if (student.is_disabled) {
        if (!student.dr_phone_no || student.dr_phone_no.trim() === "") {
          newErrors[`student_${index}_dr_phone`] =
            `${t("Doctor's")}  ${t("phone")} ${t("number")} ${t("is")} ${t("required")} ${t("for")} ${t("student")}  ${index + 1}`;
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  console.log(errors);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (Object.values(feeErrors).some(Boolean)) {
      toast.error("Please select the correct fee type for each student.");
      return;
    }
    toast.dismiss();
    try {
      let response;

      if (id) {
        response = await updateRecord({
          data: formData.students[0],
          endPoint: `student/${id}`,
        }).unwrap();

        if (response.statusCode === 200 || response.statusCode === 201) {
          setShow(true);
        }
      } else {
        response = await createRecord({
          data: formData,
          endPoint: "add-students",
        }).unwrap();

        if (response.statusCode === 200 || response.statusCode === 201) {
          toast.success(response.data.message);
          const summary = response.data?.payment_summary;
          const breakdown = response.data?.fee_breakdown || [];
          const totalNewFee = response.data?.total_fee || 0;

          if (response.data.redirect_to_payment && summary) {
            // New kids have a fee due — show payment modal
            setPaymentSummary(summary);
            setFeeBreakdown(breakdown);
            setNewStudentsFee(totalNewFee);
            setPaymentFormData({
              currency: "USD",
              paymentType: "full_payment",
            });
            setShowPaymentModal(true);
          } else {
            // No fee — go directly to success
            setShow(true);
          }
        }
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handlePaymentSubmit = async () => {
    toast.dismiss();
    try {
      const payload = { ...paymentFormData };
      if (payload.paymentType === "partial_payment") {
        payload.partialAmount = parseFloat(
          (paymentSummary.due_amount / 3).toFixed(2),
        );
      }
      const response = await parentPayment(payload).unwrap();
      if (response.statusCode === 200 || response.statusCode === 201) {
        window.open(response.data.iframe_url, "_blank");
        setShowPaymentModal(false);
        setShow(true);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleState = () => {
    const stu = data.data;
    setFormData({
      students: [
        {
          full_name: stu.full_name || "",
          street: stu.street || "",
          city: stu.city || "",
          state: stu.state || "",
          country: stu.country || "",
          zip_code: stu.zip_code || "",
          latitude: stu.latitude || "",
          longitude: stu.longitude || "",
          is_disabled: stu.is_disabled || false,
          disability_notes: stu.disability_notes || "",
          dr_phone_no: stu.dr_phone_no || "",
          status: stu.status || "",
        },
      ],
    });
  };

  const handleReset = () => {
    id ? handleState() : setFormData({ students: [initialState] });

    setErrors({});
  };

  const handleClose = () => {
    setShow(false);
    navigate("/manage-kids");
  };

  useEffect(() => {
    if (isSuccess && data?.data) {
      handleState();
    }
  }, [data, isSuccess]);

  return (
    <>
      <div className="outerBox">
        {/* Student Section */}
        <div className="d-flex mb-3">
          <button className="page-back-btn" onClick={() => navigate(-1)}>
            ← {t("back")}
          </button>
        </div>
        <div className="d-flex align-items-center justify-content-between  mb-2 text-start">
          <h5 className="fw-semibold mb-0">
            {t("add")} {t("student")} {t("details")}
          </h5>
          <button
            type="button"
            className="btn btn-primary px-4 rounded-3"
            onClick={handleAddStudent}
          >
            <FaPlus /> {t("add")} {t("student")}
          </button>
        </div>

        {formData.students.map((student, idx) => (
          <div key={idx} className="border rounded-4 p-4 mt-3 text-start check">
            <div className="row g-3">
              {/* Student Name */}
              <div className={`${id ? "" : "col-md-6"} col-12`}>
                <label className="form-label fw-semibold">
                  {t("student")} {t("name")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="formInput"
                  value={student.full_name}
                  onChange={(e) =>
                    handleChangeStudent(idx, "full_name", e.target.value)
                  }
                  required
                />
                {errors[`student_${idx}_name`] && (
                  <span className="text-danger small">
                    {errors[`student_${idx}_name`]}
                  </span>
                )}
              </div>
              {/* Fee / Service Type */}
              {!id && (
                <div className="col-md-6 col-12">
                  <label className="form-label fw-semibold">
                    {t("student")} {t("fee")}
                    <span className="text-danger"> *</span>
                    {user.is_private === 1 && (
                      <span
                        className="ms-2 px-2 rounded"
                        style={{
                          fontSize: "0.72rem",
                          fontWeight: 600,
                          background: "rgba(25,135,84,0.12)",
                          color: "#198754",
                          border: "1px solid rgba(25,135,84,0.3)",
                        }}
                      >
                        Free
                      </span>
                    )}
                  </label>
                  <FeeSelector
                    bus_fee_id={student.bus_fee_id}
                    change={(name, value) =>
                      handleChangeStudent(idx, name, value)
                    }
                    isPrivate={user.is_private}
                    studentIndex={existingStudents.length + idx}
                    firstChildTaken={
                      existingFirstChild ||
                      Object.entries(studentChildTypes).some(
                        ([i, ct]) => Number(i) !== idx && ct === "first",
                      )
                    }
                    onChildTypeChange={(ct) =>
                      setStudentChildTypes((prev) => ({ ...prev, [idx]: ct }))
                    }
                    onFeeError={(hasError) =>
                      setFeeErrors((prev) => ({ ...prev, [idx]: hasError }))
                    }
                  />
                  {errors[`student_${idx}_fee`] && (
                    <span className="text-danger small">
                      {errors[`student_${idx}_fee`]}
                    </span>
                  )}
                </div>
              )}

              {/* Address with Same as Parent Checkbox */}
              <div className="col-12">
                <label className="form-label fw-semibold d-flex align-items-center gap-3">
                  <span>
                    {t("address")} <span className="text-danger">*</span>
                  </span>
                  <Form.Check
                    type="checkbox"
                    checked={student.sameAsParent}
                    onChange={(e) =>
                      handleChangeStudent(idx, "sameAsParent", e.target.checked)
                    }
                    label={`${t("same")} ${t("as")} ${t("parent")}`}
                  />
                </label>

                <AddressAutocomplete
                  value={student.street}
                  disabled={student.sameAsParent}
                  onSelect={(addr) => handleStudentAddressSelect(idx, addr)}
                  onChange={(e) =>
                    handleChangeStudent(idx, "street", e.target.value)
                  }
                />
                {errors[`student_${idx}_street`] && (
                  <span className="text-danger small">
                    {errors[`student_${idx}_street`]}
                  </span>
                )}
              </div>

              {/* Me dical Conditions Checkbox */}
              <div className="col-12 pt-2">
                <div className="d-flex align-items-center">
                  <label
                    htmlFor={`is_disabled_${idx}`}
                    className="form-label fw-semibold d-flex align-items-center gap-3 mb-0"
                    style={{ opacity: 0.9, cursor: "pointer" }}
                  >
                    <Form.Check
                      type="checkbox"
                      id={`is_disabled_${idx}`}
                      className="me-2"
                      checked={student.is_disabled}
                      onChange={(e) =>
                        handleChangeStudent(
                          idx,
                          "is_disabled",
                          e.target.checked,
                        )
                      }
                      label={t("child_special_conditions")}
                    />
                  </label>
                </div>
              </div>

              {/* Medical Details (shown if checked) */}
              {student.is_disabled && (
                <div className="col-12 pt-3 border-top ">
                  <div className="row g-3">
                    <div className="col-md-6 col-12">
                      <label className="form-label fw-semibold">
                        {t("Doctor's")} {t("phone")} {t("number")}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        value={student.dr_phone_no}
                        onChange={(e) =>
                          handleChangeStudent(
                            idx,
                            "dr_phone_no",
                            e.target.value,
                          )
                        }
                        required
                      />
                      {errors[`student_${idx}_dr_phone`] && (
                        <span className="text-danger small">
                          {errors[`student_${idx}_dr_phone`]}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 col-12">
                      <label className="form-label fw-semibold">
                        {t("disability")} {t("notes")}
                      </label>
                      <textarea
                        className="form-control"
                        rows={3}
                        value={student.disability_notes}
                        onChange={(e) =>
                          handleChangeStudent(
                            idx,
                            "disability_notes",
                            e.target.value,
                          )
                        }
                        placeholder={`${t("describe_medical_conditions")}...`}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Delete Button */}
              <div className="col-12 d-flex justify-content-end">
                {formData.students.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-dark px-4 rounded-3 shadow-sm"
                    onClick={() => removeStudent(idx)}
                    aria-label={`Delete student ${idx + 1}`}
                  >
                    {t("btns.delete")} {t("student")}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}

        {/* Buttons */}
        <div className="pt-4 mt-3 border-top text-end">
          <Button
            variant="outline-secondary"
            onClick={handleReset}
            className="me-3 px-4 py-2"
          >
            {t("btns.reset")}
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={handleSubmit}
            disabled={isLoading || isUpdateLoading}
            className="px-4 py-2"
          >
            {isLoading || isUpdateLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                >
                  <span className="visually-hidden">{t("loading")}...</span>
                </span>
              </>
            ) : (
              t("btns.submit")
            )}
          </Button>
        </div>
      </div>

      <Modal show={show}>
        <Button className="closePopup" onClick={handleClose}>
          <IoCloseSharp />
        </Button>
        <CreateModal
          onClose={handleClose}
          title={`${t("kid")} ${id ? t("btns.update") : t("added")} ${t("successfully")}`}
          text={`${t("kid")} ${t("has")} ${t("been")} ${id ? t("updated") : t("added")}.`}
        />
      </Modal>

      {/* Payment Modal */}
      <Modal show={showPaymentModal} centered size="xl">
        <Modal.Header
          className="border-bottom pb-3"
          style={{ borderColor: "rgba(240, 178, 65, 0.3)" }}
        >
          <Modal.Title className="fw-semibold">
            {t("complete")} {t("payment")} — {t("new")} {t("student")}(s)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {/* Fee Breakdown */}
          {feeBreakdown.length > 0 && (
            <div className="ak-fee-section mb-4">
              <div className="ak-fee-header">
                <span className="ak-fee-title">
                  {t("fee")} {t("details")}
                </span>
              </div>

              {/* Previous unpaid balance */}
              {(() => {
                const prevBalance = parseFloat(
                  ((paymentSummary?.due_amount || 0) - newStudentsFee).toFixed(
                    2,
                  ),
                );
                return prevBalance > 0 ? (
                  <div className="ak-fee-row ak-prev-balance">
                    <div className="ak-fee-label">
                      <span className="ak-icon">↩</span>
                      {t("previous")} {t("unpaid")} {t("balance")}
                    </div>
                    <div className="ak-fee-amount ak-muted">
                      {paymentFormData.currency === "USD" ? "$" : "C$"}
                      {prevBalance.toFixed(2)}
                    </div>
                  </div>
                ) : null;
              })()}

              {/* Student rows */}
              {feeBreakdown.map((item, i) => (
                <div key={i} className="ak-fee-row">
                  <div className="ak-fee-label">
                    <div className="ak-student-name">
                      {item.student_name}
                      <span className="ak-new-badge">{t("new")}</span>
                    </div>
                    {item.pro_rate && (
                      <div className="ak-pro-rate-info">
                        <span className="ak-chip">
                          {item.pro_rate.remainingMonths}/
                          {item.pro_rate.totalMonths} months
                        </span>
                        <span className="ak-chip-muted">
                          {paymentFormData.currency === "USD" ? "$" : "C$"}
                          {item.pro_rate.monthlyFee}/month
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="ak-fee-amount">
                    <span className="ak-price">
                      {paymentFormData.currency === "USD" ? "$" : "C$"}
                      {parseFloat(item.fee).toFixed(2)}
                    </span>
                    {item.pro_rate && item.annual_fee > item.fee && (
                      <span className="ak-original">
                        {paymentFormData.currency === "USD" ? "$" : "C$"}
                        {parseFloat(item.annual_fee).toFixed(2)}
                      </span>
                    )}
                  </div>
                </div>
              ))}

              {/* Total row */}
              <div className="ak-fee-total">
                <span>
                  {t("total")} {t("due")}
                </span>
                <span className="ak-total-amount">
                  {paymentFormData.currency === "USD" ? "$" : "C$"}
                  {parseFloat(paymentSummary?.due_amount || 0).toFixed(2)}
                </span>
              </div>
            </div>
          )}

          <style>{`
            .ak-fee-section {
              border: 1px solid #e9ecef;
              border-radius: 10px;
              overflow: hidden;
            }
            .ak-fee-header {
              padding: 12px 16px;
              background: #f8f9fa;
              border-bottom: 1px solid #e9ecef;
            }
            .ak-fee-title {
              font-weight: 600;
              font-size: 0.9rem;
              color: #495057;
              text-transform: uppercase;
              letter-spacing: 0.04em;
            }
            .ak-fee-row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 14px 16px;
              border-bottom: 1px solid #f1f3f5;
              gap: 12px;
            }
            .ak-prev-balance {
              background: #fffbf0;
            }
            .ak-fee-label {
              flex: 1;
              min-width: 0;
            }
            .ak-student-name {
              display: flex;
              align-items: center;
              gap: 8px;
              font-weight: 500;
              color: #212529;
              font-size: 0.95rem;
            }
            .ak-new-badge {
              font-size: 0.68rem;
              font-weight: 600;
              padding: 2px 7px;
              border-radius: 20px;
              background: rgba(240, 178, 65, 0.15);
              color: #9a6800;
              border: 1px solid rgba(240, 178, 65, 0.35);
              letter-spacing: 0.03em;
            }
            .ak-pro-rate-info {
              display: flex;
              align-items: center;
              gap: 6px;
              margin-top: 5px;
              flex-wrap: wrap;
            }
            .ak-chip {
              font-size: 0.75rem;
              font-weight: 600;
              padding: 2px 8px;
              border-radius: 20px;
              background: #e8f4fd;
              color: #0c6cba;
              border: 1px solid #c5e0f7;
            }
            .ak-chip-muted {
              font-size: 0.75rem;
              padding: 2px 8px;
              border-radius: 20px;
              background: #f1f3f5;
              color: #6c757d;
              border: 1px solid #dee2e6;
            }
            .ak-fee-amount {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 2px;
              flex-shrink: 0;
            }
            .ak-price {
              font-weight: 600;
              color: #212529;
              font-size: 0.95rem;
            }
            .ak-original {
              font-size: 0.78rem;
              color: #adb5bd;
              text-decoration: line-through;
            }
            .ak-muted {
              color: #868e96 !important;
            }
            .ak-icon {
              margin-right: 6px;
              color: #adb5bd;
            }
            .ak-fee-total {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 14px 16px;
              background: #f8f9fa;
              font-weight: 600;
              font-size: 0.95rem;
              color: #343a40;
            }
            .ak-total-amount {
              font-size: 1.1rem;
              font-weight: 700;
              color: #f0b241;
            }
          `}</style>

          {/* Currency Selector */}
          <div className="mb-4">
            <h6 className="fw-semibold mb-2">
              {t("select")} {t("currency")}
            </h6>
            <div className="d-flex gap-3">
              {["USD", "CAD"].map((c) => (
                <div
                  key={c}
                  className="border rounded-3 px-4 py-2 d-flex align-items-center gap-2"
                  style={{
                    cursor: "pointer",
                    borderColor:
                      paymentFormData.currency === c ? "#f0b241" : "#dee2e6",
                    backgroundColor:
                      paymentFormData.currency === c
                        ? "rgba(240, 178, 65, 0.08)"
                        : "transparent",
                  }}
                  onClick={() =>
                    setPaymentFormData((prev) => ({ ...prev, currency: c }))
                  }
                >
                  <div className="payment-modal-radio me-1">
                    <div
                      className={`payment-modal-circle ${paymentFormData.currency === c ? "pm-checked" : ""}`}
                    />
                  </div>
                  <span
                    className={
                      paymentFormData.currency === c ? "fw-semibold" : ""
                    }
                  >
                    {c === "USD" ? t("usd_currency") : t("cad_currency")}
                  </span>
                  {c === "USD" && (
                    <span
                      className="ms-1 px-2 py-1 rounded"
                      style={{
                        fontSize: "0.72rem",
                        backgroundColor: "rgba(240, 178, 65, 0.15)",
                        color: "#b37f00",
                        border: "1px solid rgba(240, 178, 65, 0.4)",
                      }}
                    >
                      {t("default")}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Payment Type Selector */}
          <div className="mb-2">
            <h6 className="fw-semibold mb-3">
              {t("payment")} {t("type")}
            </h6>
            <div className="row g-3">
              {/* Full Payment */}
              <div className="col-md-6">
                <div
                  className="border rounded-3 p-3 h-100"
                  style={{
                    cursor: "pointer",
                    borderColor:
                      paymentFormData.paymentType === "full_payment"
                        ? "#f0b241"
                        : "#dee2e6",
                    backgroundColor:
                      paymentFormData.paymentType === "full_payment"
                        ? "rgba(240, 178, 65, 0.08)"
                        : "transparent",
                    boxShadow:
                      paymentFormData.paymentType === "full_payment"
                        ? "0 4px 12px rgba(240, 178, 65, 0.2)"
                        : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() =>
                    setPaymentFormData((prev) => ({
                      ...prev,
                      paymentType: "full_payment",
                    }))
                  }
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="payment-modal-radio">
                      <div
                        className={`payment-modal-circle ${paymentFormData.paymentType === "full_payment" ? "pm-checked" : ""}`}
                      />
                    </div>
                    <span className="fw-semibold">
                      {t("full")} {t("payment")}
                    </span>
                  </div>
                  <div className="mb-2">
                    <span
                      style={{
                        color: "#f0b241",
                        fontWeight: 700,
                        fontSize: "1.4rem",
                      }}
                    >
                      {paymentFormData.currency === "USD" ? "$" : "C$"}
                      {parseFloat(paymentSummary?.due_amount || 0).toFixed(2)}
                    </span>
                    <span className="text-muted small ms-2">
                      {t("one")} {t("time")} {t("payment")}
                    </span>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span style={{ color: "#f0b241", fontWeight: 700 }}>
                        ✓
                      </span>
                      <span className="small text-muted">
                        {t("peace_of_mind")}
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "#f0b241", fontWeight: 700 }}>
                        ✓
                      </span>
                      <span className="small text-muted">
                        {t("no")} {t("additional")} {t("fees")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Partial Payment */}
              <div className="col-md-6">
                <div
                  className="border rounded-3 p-3 h-100"
                  style={{
                    cursor: "pointer",
                    borderColor:
                      paymentFormData.paymentType === "partial_payment"
                        ? "#f0b241"
                        : "#dee2e6",
                    backgroundColor:
                      paymentFormData.paymentType === "partial_payment"
                        ? "rgba(240, 178, 65, 0.08)"
                        : "transparent",
                    boxShadow:
                      paymentFormData.paymentType === "partial_payment"
                        ? "0 4px 12px rgba(240, 178, 65, 0.2)"
                        : "none",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() =>
                    setPaymentFormData((prev) => ({
                      ...prev,
                      paymentType: "partial_payment",
                    }))
                  }
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="payment-modal-radio">
                      <div
                        className={`payment-modal-circle ${paymentFormData.paymentType === "partial_payment" ? "pm-checked" : ""}`}
                      />
                    </div>
                    <div>
                      <span className="fw-semibold">
                        {t("partial")} {t("payment")}
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "0.8rem",
                          color: "#b37f00",
                          fontWeight: 500,
                        }}
                      >
                        {t("flexible")} {t("payment")} {t("plan")}
                      </span>
                    </div>
                  </div>
                  <div className="mb-2">
                    <span
                      style={{
                        color: "#f0b241",
                        fontWeight: 700,
                        fontSize: "1.4rem",
                      }}
                    >
                      {paymentFormData.currency === "USD" ? "$" : "C$"}
                      {parseFloat(
                        ((paymentSummary?.due_amount || 0) / 3).toFixed(2),
                      )}
                    </span>
                    <span className="text-muted small ms-2">
                      × 3 {t("months")}
                    </span>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <span style={{ color: "#f0b241", fontWeight: 700 }}>
                        ✓
                      </span>
                      <span className="small text-muted">
                        {t("pay")} {t("in")} 3 {t("installments")}
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "#f0b241", fontWeight: 700 }}>
                        ✓
                      </span>
                      <span className="small text-muted">
                        {t("flexible")} {t("payment")} {t("schedule")}
                      </span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "#f0b241", fontWeight: 700 }}>
                        ✓
                      </span>
                      <span className="small text-muted">
                        {t("may_accrue_interest")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          className="border-top pt-3"
          style={{ borderColor: "rgba(240, 178, 65, 0.3)" }}
        >
          <Button
            variant="outline-secondary"
            onClick={() => {
              setShowPaymentModal(false);
              setShow(true);
            }}
            className="px-4"
          >
            {t("skip_for_now")}
          </Button>
          <button
            onClick={handlePaymentSubmit}
            disabled={isPaymentLoading}
            className="btn px-4"
            style={{
              backgroundColor: "#f0b241",
              borderColor: "#f0b241",
              color: "#fff",
              fontWeight: 600,
            }}
          >
            {isPaymentLoading ? (
              <span className="spinner-border spinner-border-sm me-2" />
            ) : null}
            {t("pay")} {paymentFormData.currency === "USD" ? "$" : "C$"}
            {parseFloat(
              paymentFormData.paymentType === "full_payment"
                ? paymentSummary?.due_amount || 0
                : (paymentSummary?.due_amount || 0) / 3,
            ).toFixed(2)}
          </button>
        </Modal.Footer>
      </Modal>

      {/* styles */}
      <style jsx>{`
        .address,
        .address:focus,
        .select__control--is-focused,
        .select__control--menu-is-open,
        .css-13cymwt-control,
        .css-13cymwt-control:hover,
        .css-t3ipsp-control:hover {
          padding: 10px 12px;
          background-color: rgb(255, 255, 255);
          color: rgb(73, 80, 87);
          font-size: 14px;
          width: 100%;
          height: 55px;
          border: 1px solid #d6d6d6;
          border-radius: 6px;
          font-weight: 500;
          box-shadow: none;
        }
        /* Custom radio circles — gold theme */
        .payment-modal-radio {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .payment-modal-circle {
          width: 18px;
          height: 18px;
          border: 2px solid #ccc;
          border-radius: 50%;
          position: relative;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }
        .payment-modal-circle.pm-checked {
          border-color: #f0b241;
        }
        .payment-modal-circle.pm-checked::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 9px;
          height: 9px;
          background-color: #f0b241;
          border-radius: 50%;
        }
      `}</style>
    </>
  );
};

export default AddKids;
